/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from "@tanstack/react-query";

import { useCallback } from "react";

import type { AiChatbotRequest, ApiResult } from "./query.schemas";

import { useCustomFetchClient } from "./mutator/custom-fetch";
import type { ErrorType, BodyType } from "./mutator/custom-fetch";

/**
 * Submit a question to the Azure AI Foundry chatbot agent and return the AI response.
 */
export const useAiChatbotQueryHook = () => {
    const aiChatbotQuery = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            aiChatbotRequest?: BodyType<AiChatbotRequest>,
            signal?: AbortSignal,
        ) => {
            return aiChatbotQuery({
                url: `/ai-chatbot/query`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: aiChatbotRequest,
                signal,
            });
        },
        [aiChatbotQuery],
    );
};

export const useAiChatbotQueryMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAiChatbotQueryHook>>>,
        TError,
        { data?: BodyType<AiChatbotRequest> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAiChatbotQueryHook>>>,
    TError,
    { data?: BodyType<AiChatbotRequest> },
    TContext
> => {
    const mutationKey = ["aiChatbotQuery"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const aiChatbotQuery = useAiChatbotQueryHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAiChatbotQueryHook>>>,
        { data?: BodyType<AiChatbotRequest> }
    > = (props) => {
        const { data } = props ?? {};

        return aiChatbotQuery(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AiChatbotQueryMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAiChatbotQueryHook>>>
>;
export type AiChatbotQueryMutationBody = BodyType<AiChatbotRequest> | undefined;
export type AiChatbotQueryMutationError = ErrorType<unknown>;

export const useAiChatbotQuery = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useAiChatbotQueryHook>>>,
            TError,
            { data?: BodyType<AiChatbotRequest> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAiChatbotQueryHook>>>,
    TError,
    { data?: BodyType<AiChatbotRequest> },
    TContext
> => {
    return useMutation(useAiChatbotQueryMutationOptions(options), queryClient);
};
